module.exports = __webpack_public_path__ + "asobi.041ad5b.png";